<template>
  <div class="message-item">
    <a-row type="flex" :class="messagePosition" :gutter="20">
      <!-- 头像 -->
      <a-col class="avatar" v-if="showAvatar">
        <a-avatar shape="square" :src="avatar || face" size="large"></a-avatar>
      </a-col>
      <!-- 消息 -->
      <a-col>
        <!-- 消息时间戳 -->
        <a-row type="flex" :gutter="10" class="time" v-if="showAvatar">
          <a-col>{{ from }}</a-col>
          <a-col>{{ time }}</a-col>
        </a-row>
        <!-- 消息体 -->
        <a-row type="flex" :gutter="10" align="middle" class="message">
          <a-col class="box">
            <text-elem
              v-if="message.type === $TIM.TYPES.MSG_TEXT"
              :payload="message.payload"
            ></text-elem>
            <image-elem
              v-else-if="message.type === $TIM.TYPES.MSG_IMAGE"
              :payload="message.payload"
            ></image-elem>
            <file-elem
              v-else-if="message.type === $TIM.TYPES.MSG_FILE"
              :payload="transformKey(message.payload)"
            />
            <sound-elem
              v-else-if="message.type === $TIM.TYPES.MSG_SOUND"
              :payload="message.payload"
            />
            <group-tip-elem
              v-else-if="message.type === $TIM.TYPES.MSG_GRP_TIP"
              :payload="message.payload"
            />
            <video-elem
              v-else-if="message.type === $TIM.TYPES.MSG_VIDEO"
              :payload="transformKey(message.payload)"
            />
            <custom-elem
              v-else-if="message.type === $TIM.TYPES.MSG_CUSTOM"
              :payload="message.payload"
            ></custom-elem>
            <span v-else>暂未支持的消息类型：{{ message.type }}</span>
          </a-col>
          <!-- 消息状态 -->
          <a-col v-if="isMine">
            <a-icon
              style="font-size:16px"
              type="loading"
              v-if="message.status === 'unSend'"
            />
            <a-icon
              style="color:red;font-size:16px"
              type="exclamation"
              v-if="message.status === 'fail'"
              @click="resendMessage(message)"
              title="重新发送"
            />
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CustomElem from "./message-elem/custom-elem";
import TextElem from "./message-elem/text-elem";
import ImageElem from "./message-elem/image-elem";
import GroupTipElem from "./message-elem/group-tip-elem";
import FileElem from "./message-elem/file-elem";
import SoundElem from "./message-elem/sound-elem";
import VideoElem from "./message-elem/video-elem";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";
const { mapState } = createNamespacedHelpers("im");
export default {
  name: "MessageItem",
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      face: require("@/assets/avatar.png")
    };
  },
  provide() {
    return {
      message: this.message
    };
  },
  components: {
    CustomElem,
    TextElem,
    ImageElem,
    GroupTipElem,
    FileElem,
    SoundElem,
    VideoElem
  },
  computed: {
    ...mapState(["currentConversation"]),
    isMine() {
      return this.message.flow === "out";
    },
    msgType() {
      let data = this.jsonParse(this.message.payload.data);
      return data.type ? data.type : data;
    },
    msgPayload() {
      let data = this.jsonParse(this.message.payload.data);
      return data.type ? data.value : this.message.payload;
    },
    messagePosition() {
      if (
        ["TIMGroupTipElem", "TIMGroupSystemNoticeElem"].includes(
          this.message.type
        )
      ) {
        return "position-center";
      }
      if (this.isMine) {
        return "position-right";
      } else {
        return "position-left";
      }
    },
    showMessageHeader() {
      if (
        ["TIMGroupTipElem", "TIMGroupSystemNoticeElem"].includes(
          this.message.type
        )
      ) {
        return false;
      }
      return true;
    },
    // 是否显示头像，群提示消息不显示头像
    showAvatar() {
      if (this.currentConversation.type === "C2C") {
        return true;
      } else if (this.currentConversation.type === "GROUP") {
        return this.message.type !== this.$TIM.TYPES.MSG_GRP_TIP;
      }
      return false;
    },
    from() {
      const isC2C = this.currentConversation.type === this.$TIM.TYPES.CONV_C2C;
      // 自己发送的用昵称渲染
      if (this.isMine) {
        return this.$store.state.user.name;
      }
      // 1. C2C 的消息体中还无 nick / avatar 字段，需从 conversation.userProfile 中获取
      if (isC2C) {
        return (
          this.currentConversation.userProfile.nick ||
          this.currentConversation.userProfile.userID
        );
      } else if (
        this.currentConversation.type === this.$TIM.TYPES.CONV_SYSTEM
      ) {
        return this.message.type === this.$TIM.TYPES.MSG_GRP_SYS_NOTICE
          ? "群系统通知"
          : "系统通知";
      }
      // 2. 群组消息，用消息体中的 nick 渲染。nameCard暂时支持不完善
      return this.message.nick || this.message.from;
    },
    avatar() {
      if (this.currentConversation.type === "C2C") {
        return this.isMine
          ? this.$store.state.user.picture
          : this.currentConversation.userProfile.avatar;
      } else if (this.currentConversation.type === "GROUP") {
        return this.isMine
          ? this.$store.state.user.picture
          : this.message.avatar;
      } else {
        return "";
      }
    },
    time() {
      const date = moment(this.message.time * 1000);
      if (date.date() === moment().date()) {
        return date.format("HH:mm:ss");
      }
      return date.format("YYYY-MM-DD HH:mm:ss");
    }
  },
  created() {
    // console.log("message", this.message);
  },
  methods: {
    jsonParse(str) {
      try {
        let val = JSON.parse(str);
        return val;
      } catch (e) {
        return str;
      }
    },
    transformKey(message) {
      let obj = {};
      for (const key in message) {
        let str = key.replace(key[0], key[0].toLowerCase());
        obj[str] = message[key];
      }
      return obj;
    },
    async resendMessage(message) {
      try {
        await this.$tim.resendMessage(message);
      } catch (error) {
        this.$message.fail(error.message);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.message-item {
  padding: 5px 16px 10px;
  .avatar {
    padding-top: 10px;
  }
  .position-right {
    flex-direction: row-reverse;
    .time {
      flex-direction: row-reverse;
    }
    .message {
      flex-direction: row-reverse;
      .box {
        color: #fff;
        border-radius: 6px 0 6px 6px;
        background: linear-gradient(
          90deg,
          rgba(90, 196, 255, 1) 0%,
          rgba(62, 182, 255, 1) 50%,
          rgba(92, 149, 255, 1) 100%
        );
      }
    }
  }
  ::v-deep .position-left .message .box {
    .divider {
      color: #333;
    }
    .downLoad {
      color: #00a4ff;
    }
  }
  .position-center {
    justify-content: center;
    .time {
      justify-content: center;
      margin-bottom: 0;
    }
    .message {
      .box {
        background: none;
        box-shadow: none;
      }
    }
  }
  .time {
    color: #a5b5c1;
    font-size: 12px;
    margin-bottom: 5px;
    position: relative;
  }
  .message {
    .box {
      background: #e0e2e7;
      border-radius: 0 6px 6px 6px;
      color: #333;
      font-size: 14px;
      position: relative;
      max-width: 350px;
      word-wrap: break-word;
      word-break: break-all;
      padding: 10px 18px !important;
      box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
      &::after {
        content: "";
        position: absolute;
      }
    }
  }
}
</style>
